import React, { useState } from 'react';
import Meta from './Meta'; 
import wifiImage from './assets/wi-fi.jpg';

export default function ChtoDelatEsliInternetPropal() {

   return (
         <>
    <Meta
    title="Восстановление интернета, когда нет соединения | ИТ Особа"
    description="Пропал интернет дома или в офисе? Наше экспертное руководство из 7 шагов поможет самостоятельно диагностировать и устранить 90% причин отсутствия связи за 15 минут. Читайте и возвращайтесь онлайн!"
    />

    <div
    style={{
            fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
            maxWidth: '900px',
            margin: '0 auto',
            padding: '40px 20px',
            lineHeight: 1.6,
            backgroundColor: '#f9f9f9',
            color: '#333',
            }}
    >
        <h1
    style={{
    textAlign: 'center',
    marginBottom: '30px',
    color: '#2c3e50',
    }}
    >
    Что делать, если интернет пропал?
    </h1>

    <section>
        <p style={{ float: 'right', maxWidth: '40%', marginLeft: '20px', marginBottom: '10px' }}>
                 <img src={wifiImage} alt="Wi-fi Illustration" style={{ width: '100%', height: 'auto' }} />
            </p>
    <p>
    Раздражение, беспокойство, потеря времени — знакомые чувства, когда внезапно пропадает интернет. В современном мире это сравнимо с отключением электричества: зависает трансляция, обрывается важный звонок, не грузятся документы. Первый порыв — сразу набрать техподдержку провайдера. Но часто причина кроется на вашей стороне, и её можно устранить за несколько минут.</p>
    <p>
    Эта статья — ваш понятный и подробный план действий. Мы выстроили шаги от самых простых и частых решений к более сложным. Пройдите по ним последовательно, и с высокой вероятностью вы вернёте себе доступ в сеть, сэкономив время и нервы. Поехали!
    </p>
    </section>
    <section>
    <h2
        style={{
        textAlign: 'center',
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    > Шаг 1: Базовая диагностика «на глаз» </h2>
    <p> Прежде чем что-либо перезагружать, проведите быстрый визуальный осмотр.</p>
    <h4
        style={{
        marginBottom: '30px',
        color: '#2c3e50',
        }}
    > Определите масштаб проблемы: </h4>
    <ul>
    <li><strong>Не работает на одном устройстве</strong> (например, на ноутбуке), но
                    есть
                    на
                    телефоне? → Проблема
                    скорее
                    всего
                    в
                    устройстве, а
                    не
                    в
                    сети. </li>
                    <li><strong>Не
                    работает
                    на
                    всех
                    устройствах</strong> (телефоны, ноутбук, Smart
                    TV) одновременно? → Проблема
                    в
                    роутере
                    или
                    у
                    провайдера. </li>
                    <li><strong>Пропал
                    интернет
                    по
                    кабелю, но
                    Wi-Fi
                    есть</strong> (или
                    наоборот)? → Проблема
                    может
                    быть
                    в
                    конкретном
                    интерфейсе
                    роутера
                    или
                    сетевой
                    карте. </li>
           </ul>

               <h4
                style = {{
                            marginBottom: '30px',
                           color: '#2c3e50',
}}
>
Посмотрите
на
индикаторы (лампочки)
роутера. </h4>
             <p> Это
ключевой
источник
информации. Типичная
схема (может
отличаться
в
зависимости
от
модели): </p>
             <ul>
                                     <li><strong>Power (PWR):</strong> Должна
                        гореть
                        постоянно. Не
                        горит? Проверьте
                        подключение
                        блока
                        питания
                        к
                        розетке
                        и
                        роутеру. </li>
                                     <li><strong>Internet/WAN/Globe:</strong> Эта
                        лампочка (часто
                        синяя
                        или
                        зелёная) указывает
                        на
                        наличие
                        связи
                        с
                        провайдером. Если
                        она
                        не
                        горит
                        или
                        мигает
                        красным/оранжевым — проблема
                        на
                        линии
                        от
                        провайдера
                        до
                        вас. Это
                        повод
                        для
                        звонка
                        в
                        поддержку. </li>
                                       <li><strong>Wi-Fi:</strong> Должна
                        гореть
                        или
                        мигать, указывая
                        на
                        активность
                        беспроводной
                        сети. </li>
                                  <li><strong>LAN (1, 2, 3, 4):</strong> Горит
                        или
                        мигает
                        только
                        на
                        том
                        порту, к
                        которому
                        подключён
                        кабель
                        от
                        компьютера
                        или
                        ТВ-приставки. </li>
                                            </ul>
                        <p><strong>Вывод
после
Шага 1:</strong>
Если
индикатор
Internet
не
активен, переходите
сразу
к
Шагу
5.
Если
горит, но
интернета
нет — двигаемся
дальше. </p>
            </section>

<section>
                <h2
                style = {{
                            textAlign: 'center',
                            marginBottom: '30px',
                            color: '#2c3e50',
                            }}
                            > Шаг
                            2: Магия
                            перезагрузки (90% проблем
                            решаются
                            здесь) </h2>
           <p> Это
не
шутка. Роутер — это
мини-компьютер, работающий
24/7.
В
его
памяти
могут
возникать
сбои, конфликты
IP-адресов (так
называемый «арпинг»), зависания
процессов. Перезагрузка
очищает
память
и
переустанавливает
соединение
с
провайдером. </p>
                 <h3
                  style = {{
                              textAlign: 'center',
                            marginBottom: '30px',
color: '#2c3e50',
}}
> Как
перезагрузить
ПРАВИЛЬНО: </h3>
               <ol>
                           <li>
                           Выключите
            роутер
            кнопкой
            на
            задней
            панели
            или
            вытащите
            блок
            питания
            из
            розетки.
            </li>
            
                <li>
                Подождите
            1-2
            минуты. Это
            критически
            важно! За
            это
            время
            оборудование
            провайдера
            на
            другом
            конце
            линии «поймёт», что
            ваше
            устройство
            отключилось, и
            освободит
            IP-адрес.
            </li>
            
                <li>
                Включите
            роутер
            обратно.
            </li>
            
                <li>
                Подождите
            3-5
            минут, пока
            все
            индикаторы
            загорятся
            в
            штатном
            режиме. Особенно
            дождитесь
            стабильного
            свечения
            индикатора
            Internet/WAN.
            </li>
            
                <li>
                Проверьте
            подключение.
            </li>
    </ol>
        <p> Параллельно
перезагрузите
то
устройство, с
которого
выходите
в
сеть (компьютер, смартфон, телевизор). На
ПК
используйте
полную
перезагрузку, а
не
сон/гибернацию. </p>
                      <p><strong>Профессиональный
совет:</strong> Если
перезагрузка
помогает, но
проблема
возвращается
через
несколько
часов/дней, возможны
перегрев
роутера, устаревшая
прошивка
или
проблемы
с
блоком
питания. Подумайте
о
его
замене. </p>

            <h2
            style = {{
                        textAlign: 'center',
                        marginBottom: '30px',
                        color: '#2c3e50',
                        }}
> Шаг
3: Проверка
кабелей
и
подключений </h2>
                <p> Физический
обрыв
или
плохой
контакт — частая
причина. </p>
             <ul>
             <li> Проверьте
кабель
от
роутера
к
розетке (WAN-кабель): Убедитесь, что
он
плотно
вставлен
в
WAN-порт
роутера (обычно
выделен
цветом
или
подписан, часто
один). Проверьте
соединение
на
стороне
розетки
в
стене/полу. </li>
                  <li> Проверьте
кабель
от
компьютера
к
роутеру (LAN-кабель): Если
используете
проводное
подключение, проверьте
оба
конца. Попробуйте
переключить
кабель
в
другой
LAN-порт (1, 2, 3, 4)
на
роутере. </li>
             <li> Попробуйте
другой
кабель, если
есть
запасной. Особенно
актуально
в
домах
с
животными
или
где
кабель
часто
перемещают. </li>
                <li> Для
Wi-Fi: Убедитесь, что
на
роутере
не
нажата
кнопка
физического
отключения
Wi-Fi (на
некоторых
моделях
она
есть).</li>
          </ul>
              <h2
               style = {{
                           textAlign: 'center',
                          marginBottom: '30px',
color: '#2c3e50',
}}
> Шаг
4: Диагностика
средствами
вашей
ОС </h2>
       <p> Если
соединение
активно, но
доступа
нет, система
может
помочь. </p>
            <p> <strong> На
Windows: </strong> </p>
                          <ul>
                          <li> Нажмите
Win + R, введите
ncpa.cpl
и
нажмите
Enter. </li>
           <li> Найдите
ваше
подключение(по
Wi-Fi
или
Ethernet). Если
значок
серый
с
надписью «Отключено» — щёлкните
правой
кнопкой
мыши
и
выберите «Включить».</li>
                        <li> Если
на
значке
горит
жёлтый
восклицательный
знак, система
видит
сеть, но
доступа
к
интернету
нет. Щёлкните
правой
кнопкой
и
выберите «Диагностика
неполадок». Мастер
Windows
часто
может
автоматически
сбросить
настройки
сетевого
адаптера
или
исправить
ошибку
IP. </li>
        </ul>
            <p><strong>Ручной
сброс
сетевого
стека(мощный
способ):</strong> </p>
             <p> Откройте
командную
строку
от
имени
администратора
и
выполните
две
команды
по
очереди: </p>
             <p><strong>netsh
winsock
reset </strong></p>
          <p><strong>netsh
int
ip
reset</strong></p>
          <p> Перезагрузите
компьютер
после
этого. </p>
           <p><strong>На
Android/iOS:</strong> </p>
                   <li> Включите
и
выключите
Режим
полёта
на
10
секунд. </li>
            <li> Забудьте
сеть
Wi-Fi(в
настройках
Wi-Fi
выберите
вашу
сеть
и
нажмите «Удалить»/«Забыть»), затем
подключитесь
заново, введя
пароль. </li>
            <h2
            style = {{
                        textAlign: 'center',
                        marginBottom: '30px',
                        color: '#2c3e50',
                        }}
> Шаг
5: Вход
в
веб-интерфейс
роутера
и
проверка
статуса </h2>
            <p> Если
индикатор
Internet
не
горит, но
кабели
в
порядке, заглянем «внутрь» роутера. </p>
                                        <ul>
                                        <li> Найдите
данные
для
входа: Они
обычно
на
наклейке
на
самом
роутере. </li>
             <li> Введите
IP-адрес
в
строку
браузера
устройства, подключённого
к
этому
роутеру. </li>
             <li> Введите
логин/пароль. </li>
                    <li> Найдите
раздел «Состояние» (Status), «Карта
сети» или «Информация
о
системе».</li>
             <li> Проверьте
статус
WAN-подключения. Могут
быть
варианты:
<ul>
  <li>«Подключено» (Connected), есть
IP-адрес
и
DNS-сервера → Роутер
онлайн, проблема
в
настройках
устройства
или
ограничениях. </li>
                  <li>«Аутентификация...», «Подключается» → Роутер
не
может «представиться» оборудованию
провайдера. Проверьте
логин
и
пароль
для
подключения (PPPoE), указанные
в
договоре. Важно: это
не
пароль
от
Wi-Fi! </li>
             <li>«Не
подключено» (Disconnected), «Получение
IP-адреса» → Роутер
не
видит
сигнал
от
провайдера. Вероятность
проблемы
на
линии
или
у
провайдера — 99 %.</li>
                      </ul>
                          </li>
                              </ul>
                                  <h2
                                   style = {{
                                               textAlign: 'center',
                                               marginBottom: '30px',
                                               color: '#2c3e50',
                                                }}
> Шаг
6: Позвонить
в
техподдержку
провайдера (вооружившись
информацией)</h2>
   <p> Если
предыдущие
шаги
не
помогли, скорее
всего, проблема
на
стороне
провайдера (авария
на
линии, работы, сбой
в
оборудовании) или
требуется
удалённая
диагностика. </p>

                 <p><strong>Чтобы
звонок
был
максимально
эффективным, подготовьте:</strong> </p>
                              <ul>
                              <li> Номер
договора
или
лицевой
счёт. </li>
          <li> Ваш
адрес. </li>
           <li> Модель
вашего
роутера. </li>
             <li> Что
вы
уже
сделали? («Я перезагружал роутер, проверял кабели, индикатор WAN не горит»). Это
сразу
покажет, что
вы
не
новичок, и
оператор
перейдёт
к
сути. </li>
          <li> Опишите
симптомы («Интернет
пропал
внезапно
в
18: 00», «Нет
связи
на
всех
устройствах», «Индикатор
интернета
мигает
красным»).</li>
              </ul>

                  <p><strong>Чем
может
помочь
оператор:</strong> </p>
              <ul>
              <li> Проверить
наличие
аварии
в
вашем
доме/районе. </li>
                   <li> Дистанционно
подать
сигнал
на
ваш
роутер
и
проверить
его
ответ. </li>
           <li> Запустить
удалённую
диагностику
линии. </li>
           <li> Сбросить
или
перенастроить
ваше
подключение
на
своём
оборудовании. </li>
                  <li> При
необходимости, создать
заявку
для
выезда
мастера. </li>
             </ul>
                 <h2
                  style = {{
                              textAlign: 'center',
                            marginBottom: '30px',
color: '#2c3e50',
}}
> Шаг
7: Что
делать, если
проблема
в
устройстве </h2>
  
  
   <p> Если
интернет
есть
на
других
гаджетах, но
не
работает
на
одном
конкретном (часто
ПК): </p>
         <ul>
         <li><strong> Проверьте
настройки
антивируса
и
файервола. </strong> Иногда
они
могут
блокировать
весь
сетевой
трафик. Попробуйте
на
время
отключить
защиту (только
для
диагностики!) и
проверьте
доступ. </li>
            <li> <strong> Сбросьте
настройки
DNS. < / strong > В
командной
строке(cmd)
от
имени
администратора
выполните: </li>
               <pre>
        ipconfig / flushdns
        </pre>
            <li> <strong> Пропишите
публичные
DNS-серверы
от
Google </strong> (8.8.8.8, 8.8.4.4)
в
свойствах
вашего
сетевого
подключения. </li>
                 <li><strong> Обновите
драйвер
сетевого
адаптера. </strong> Зайдите
в
Диспетчер
устройств (Win + R -> devmgmt.msc), найдите «Сетевые
адаптеры», выберите
ваш(Wi-Fi
или
Ethernet), щёлкните
правой
кнопкой -> «Обновить
драйвер».</li>
             <li> <strong> Крайняя
мера — откат
системы. </strong> Если
проблема
появилась
недавно, используйте
точку
восстановления
Windows
на
дату, когда
интернет
работал. </li>
             </ul>

                 <h3 style = {{
                              textAlign: 'center',
                            marginBottom: '30px',
color: '#2c3e50',
}}> Заключение </h3>
                                             <p> В
8
из
10
случаев
пропажи
интернета
достаточно
первых
трёх
шагов: взглянуть
на
роутер, перезагрузить
его, проверить
провода. Эта
простая
последовательность
сэкономит
вам
кучу
времени. </p>
             <p> Но
если
проблема
оказывается
глубже — не
отчаивайтесь. Наша
техническая
поддержка
работает
24/7
и
готова
помочь
вам
на
любом
этапе. Специалисты
дистанционно
диагностируют
линию
до
вашей
квартиры
и
быстро
найдут
причину. </p>
   
   
                     </section>
                     <section style={{ textAlign: 'center', marginTop: '40px' }}>
                          <a href="/help" class="read-more-button" style={{
                                                                            backgroundColor: '#2980b9',
                                                                            color: '#fff',
                                                                            border: 'none',
                                                                            borderRadius: '6px',
                                                                            padding: '14px 30px',
                                                                            fontSize: '1.1em',
                                                                            fontWeight: '600',
                                                                            cursor: 'pointer',
                                                                            textDecoration: 'none',
                                                                            transition: 'background-color 0.3s',
                                                                          }}
                                                                          onMouseEnter={e => (e.currentTarget.style.backgroundColor = '#2471a3')}
                                                                          onMouseLeave={e => (e.currentTarget.style.backgroundColor = '#2980b9')}>Читать другие статьи</a>
                     </section>
      </div>


    </>
  );
}